// extracted by mini-css-extract-plugin
export default {"list":"ProductList_list__BVK1Q","item":"ProductList_item__DbNM1"};